import { render } from "./Pieces.vue?vue&type=template&id=6624597a"
import script from "./Pieces.vue?vue&type=script&lang=js"
export * from "./Pieces.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__